module.exports = __webpack_public_path__ + "static/media/NunitoSans_7pt-Medium.d7b72fa3.ttf";